<template>
  <div class="page-application-queue">
    <loan-work-queue-card :layout="layoutData" :loanPhase="assist.dataType.LoanPhaseEnum.LOAN_ORIGINATION.value"></loan-work-queue-card>
  </div>
</template>

<script>
import { LOS_QUEUE_LAYOUT_SETTING } from '@/setting/layout/pre-origination/queue'
import { DataType } from '@/util/index'
import { SystemEnum } from '@/assets/js'
export default {
  data () {
    return {
      assist: {
        dataType: DataType
      },
      layoutData: {
        setting: {
          workQueue: LOS_QUEUE_LAYOUT_SETTING.QUEUE,
          item: LOS_QUEUE_LAYOUT_SETTING.ITEM
        },
        sortBy: [
          SystemEnum.SORT_ORDER_BY.CREATED_AT_DESC,
          SystemEnum.SORT_ORDER_BY.CREATED_AT_ASC,
          SystemEnum.SORT_ORDER_BY.UPDATED_AT_DESC,
          SystemEnum.SORT_ORDER_BY.UPDATED_AT_ASC,
          SystemEnum.SORT_ORDER_BY.SUBMITTED_AT_DESC,
          SystemEnum.SORT_ORDER_BY.SUBMITTED_AT_ASC,
          SystemEnum.SORT_ORDER_BY.DISBURSED_AT_DESC,
          SystemEnum.SORT_ORDER_BY.DISBURSED_AT_ASC
        ]
      }
    }
  }
}
</script>
